import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {Select} from "antd";
import {listShippingLevel} from "../../../helpers/filtersTable";

AddTagInput.propTypes = {
    label: PropTypes.string.isRequired,
    value_first: PropTypes.array,
    onChange: PropTypes.func.isRequired
}

function AddTagInput(props) {
    const [inputValueFirst, setInputValueFirst] = useState('')
    const [isPaste, setIsPaste] = useState(false)

    function arrayUnique(array) {
        const a = array.concat()

        for (let i = 0; i < a.length; ++i) {
            for (let j = i + 1; j < a.length; ++j) {
                if (a[i] === a[j])
                    a.splice(j--, 1)
            }
        }

        return a
    }

    function _convertString(string) {
        const regex = /,\n|,|\s/
        const parsed = string.split(regex)
        let check = !!parsed && parsed.length > 0 && parsed.filter(item => item !== "")
        let combinedArray = [].concat(value_first)

        if (combinedArray.length === 0) {
            return check
        } else {
            return check.filter(x => !combinedArray.includes(x))
        }
    }

    function _checkString(string) {
        const regex = /,\n|,|\s/gi

        return regex.test(string)
    }

    function _onPasteInputFirst(e) {
        const value = e.clipboardData.getData('Text')
        setIsPaste(true)
        const {onChange} = props
        const input = _convertString(value)
        const newValue = arrayUnique(value_first.concat(input))

        if (typeof onChange === 'function') {
            onChange(newValue)
        }
    }

    function _handleChangeInputFirst(e) {
        const {value} = e.target
        setInputValueFirst(value)
        const {onChange} = props
        const input = _convertString(value)
        const check = _checkString(value)
        
        if ((!!input && input.length > 0 && check) || (input.length === 0 && check)) {
            const newValue = arrayUnique(value_first.concat(input))

            if (typeof onChange === 'function') {
                onChange(newValue)
                setInputValueFirst('')
            }
        }
        if(isPaste) setInputValueFirst('')
        setIsPaste(false)
    }

    function _onRemoveValueFirst(value) {
        const {onChange} = props
        const newArray = value_first.filter(item => item !== value)

        if (typeof onChange === 'function') {
            onChange(newArray)
        }
    }

    function _handleChangeInputShippingLevel(value){
        const {onChangeShippingLevel} = props

        if (typeof onChangeShippingLevel === 'function') {
            onChangeShippingLevel(value)
        }
    }

    const {label, value_first, validate, shipping_level, validateShippingLevel} = props

    return (
        <div className="SettingRulerInput">
            <label>{label}</label>
            <div className='ListInput'>
                <label>Add tag for order:</label>
                <div className={(!!validate && validate.length > 0) ? 'CustomSelect ant-input Error' : 'CustomSelect ant-input'}>
                    <div className="Selected selected-textarea">
                        {
                            !!value_first && value_first.length > 0 && value_first.map((item, index) => (
                                <span key={`allow-${index}`}>
                                    {item}
                                    <i
                                        className='icon-cross3 ml-1'
                                        onClick={() => _onRemoveValueFirst(item)}
                                    />
                                </span>
                            ))
                        }

                        <div className="Input">
                            <input
                                type="text"
                                value={inputValueFirst}
                                name='tag'
                                onPaste={_onPasteInputFirst}
                                onChange={_handleChangeInputFirst}
                            />

                            {/*<textarea*/}
                            {/*    value={inputValueFirst}*/}
                            {/*    onPaste={_onPasteInputFirst}*/}
                            {/*    onChange={_handleChangeInputFirst}*/}
                            {/*    rows='1'*/}
                            {/*/>*/}
                        </div>
                    </div>
                </div>

                {
                    !!validate && validate.length > 0 && <small className="Validate">{validate}</small>
                }

                <div className="SelectInput">
                    <label className="mt-2">Shipping Level:</label>

                    <Select value={shipping_level.toString()} onChange={_handleChangeInputShippingLevel}>
                        {
                            !!listShippingLevel && listShippingLevel.length > 0 && listShippingLevel.map(item => (
                                <Select.Option key={item.value} value={item.value}>{item.name}</Select.Option>
                            ))
                        }
                    </Select>
                </div>

                {
                    !!validateShippingLevel && validateShippingLevel.length > 0 && <small className="Validate">{validateShippingLevel}</small>
                }
            </div>
        </div>
    )
}

export default AddTagInput
